import { render, staticRenderFns } from "./ClassificationCell.vue?vue&type=template&id=50b4bf67&scoped=true&"
import script from "./ClassificationCell.vue?vue&type=script&lang=js&"
export * from "./ClassificationCell.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationCell.vue?vue&type=style&index=0&id=50b4bf67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4bf67",
  null
  
)

export default component.exports